import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { Name } from '@/src/views/G2GatedAsset/QuoteSlice';
import QuoteIcon from '@/src/views/G2GatedAsset/assets/quote-icon.svg';
import {
  Quote,
  ContentWrapper,
  QuoteWrapper,
  Position,
} from '@/src/views/GlobalBenefitsReport/slices/QuoteSlice';

export const SectionWrapper = styled.section`
  ${fluidProp(['padding-bottom', 'padding-top'], '70px', '90px')};
  text-align: center;
  background-color: #fbf9ff;
  font-family: var(--typography-fontBrand);
`;

export const Label = styled.div`
  ${({ theme }) => theme.typography.body}
  text-transform: uppercase;
  margin-bottom: 10px;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale3}
  color: var(--primaryColor);
  font-family: var(--typography-fontBossa);
  ${fluidProp('font-size', '34px', '42px')}

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.titleSM}
  color: ${({ theme }) => theme.colors.darkBlue_75};
  font-weight: 400;
  line-height: 1.5;
  margin-top: 50px;
`;

const IllustrationWrapper = styled.div`
  max-width: 300px;
  margin-bottom: 20px;

  ${desktopBreakpoint(css`
    margin-top: 20px;
  `)}

  img {
    border-radius: 50%;
  }
`;

const QuotePerson = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: var(--typography-fontBossa);

  * + * {
    margin-bottom: 10px;
  }
`;

export function QuoteSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, title, illustration, quote, name, position, description } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {fieldHasContent(label) && <Label>{label}</Label>}
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        <QuoteWrapper>
          <ContentWrapper>
            <QuoteIcon />
            {fieldHasContent(quote) && (
              <Quote>
                <PrismicRichText field={quote} />
              </Quote>
            )}
          </ContentWrapper>
          <QuotePerson>
            {illustration && (
              <IllustrationWrapper>
                <Image
                  src={illustration?.url}
                  alt={illustration?.alt || ''}
                  width={illustration?.dimensions.width}
                  height={illustration?.dimensions.height}
                  quality="100"
                />
              </IllustrationWrapper>
            )}
            {fieldHasContent(name) && <Name>{name}</Name>}
            {fieldHasContent(position) && <Position>{position}</Position>}
          </QuotePerson>
        </QuoteWrapper>
        {fieldHasContent(description) && (
          <Description>
            <PrismicRichText field={description} />
          </Description>
        )}
      </ContentContainer>
    </SectionWrapper>
  );
}
